/**
 * enum for modal window actions
 */
export enum RegexpEnum {
    /**
     * Pattern for field password : 11+ symbols, small+capital, digits, alpha, special character
     */
    passwordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z\\d]).{10,}$',

    // unified pattern: lowercase + uppercase + digit + any special character, 10+ chars
    passwordPatternNew = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z\\d]).{10,}$',
    /**
     * Pattern for field username : 8+ symbols, small+capital, digits
     */
    usernamePattern = '(?=(.*[a-zA-Z]){3})[0-9a-zA-Z]{8,}',
    /**
     * Pattern for field email: symbols, small+capital, hyphen, lower emphasis, @
     */
    email = '^[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)*@([a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+|\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])$',
    /**
     * Pattern for field phone: numbers, plus
     */
    phone = '(^[+][0-9]|[0-9])*',
    /**
     * Pattern for field name: the field should not contain only spaces
     */
    name = '^(?=.*\\S).+$'

}
